function importAll(r) {
    r.keys().forEach(r);
}

importAll(require.context("../images", true, /\.(jpg|jpeg|png|svg)$/));